var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4 3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF4F4F",
    d: "M9.296 0c1.226 0 2.223.946 2.223 2.11v.454h2.259c1.225 0 2.222.946 2.222 2.11v1.76h-1.481v9.457c0 1.163-.997 2.109-2.223 2.109H3.704c-1.226 0-2.223-.946-2.223-2.11V6.435H0v-1.76c0-1.164.997-2.11 2.222-2.11h2.26V2.11C4.481.946 5.477 0 6.703 0zm3.741 6.434H2.963v9.457c0 .387.332.703.74.703h8.593c.409 0 .741-.316.741-.703V6.434zM9 8v8H7V8h2zm3 0v8h-2V8h2zM6 8v8H4V8h2zm7.778-4.03H2.222c-.408 0-.74.316-.74.703v.354h13.037v-.354c0-.387-.333-.703-.741-.703zM9.296 1.406H6.704c-.409 0-.741.316-.741.703v.455h4.074V2.11c0-.387-.332-.703-.74-.703z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed);
export default __webpack_public_path__ + "static/media/delete-red.51c3b8a71daa88a54d68590a946fa785.svg";
export { ForwardRef as ReactComponent };